const initialState = {
  reservations: [],
  pendingReservations: [],
  forceInformationOnly: false,
};

export default initialState;
